import { resolveQuerySelector, setText, type QuerySelector } from './dom';
import type { ComparisonLine } from './statsText';

export interface StatsViewPort {
  setComparison(line: ComparisonLine | null): void;
  setActivity(text: string | null): void;
}

export interface StatsViewDeps {
  readonly querySelector?: QuerySelector;
}

/**
 * 分析データは「取れたら出す」補助表示なので、DOM は index.html に最初から
 * 置いておき、ここでは hidden の付け外しだけを行う。要素を生成しないので
 * 取得できなかった環境でもレイアウトは 1 行ぶんも動かない。
 */
export function createStatsView(deps: StatsViewDeps = {}): StatsViewPort {
  const querySelector = resolveQuerySelector(deps.querySelector);
  const comparisonRow = querySelector<HTMLElement>('#result-compare-row');
  const comparisonLabel = querySelector<HTMLElement>('#result-compare-label');
  const comparisonValue = querySelector<HTMLElement>('#result-compare-value');
  const activityRow = querySelector<HTMLElement>('#activity-note');
  const activityText = querySelector<HTMLElement>('#activity-note-text');

  return {
    setComparison: (line) => {
      if (line !== null) {
        setText(comparisonLabel, line.label);
        setText(comparisonValue, line.value);
      }
      if (comparisonRow !== null) {
        comparisonRow.hidden = line === null;
      }
    },
    setActivity: (text) => {
      if (text !== null) {
        setText(activityText, text);
      }
      if (activityRow !== null) {
        activityRow.hidden = text === null;
      }
    },
  };
}
